import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'decoding-assessment',
})

export default class DecodingAssessment extends Vue {

  // ----------------------------------------------------
    // Properties

    @Prop()
    private content!: any;


    @Prop()
    private showCorrect!: boolean;


    private isPause: boolean = false;

    /*
     * Hold the audio details
     */
    private audioRecorder: any = null;


    private get userAnswer() {
        const content = this.content;
        const userAnswer = content.userAnswer;
        return userAnswer;
    }

    private get question() {
        const question = this.content.resource;
        return question;
    }

    private get baseQuestions() {
        return this.question.answers;
    }

    private get answerObject() {
        return this.content.answerObject;
    }

    private get answers() {
      return this.showCorrect ? this.baseQuestions : this.answerObject;
    }

    private answerIndex: number = 0;

    // ---------------------------------------------------------------
    // Hooks


    // -----------------------------------------------------------------
    // Actions

    private onPlayAudio(container: any, url: any, index: number) {
      const component = this;
      let audio = component.audioRecorder;
      if (!audio || component.answerIndex !== index) {
        audio = new Audio(url);
        component.answerIndex = index ;
      }
      component.audioRecorder = audio;
      audio.play();
      component.isPause = true;
      audio.ontimeupdate = () => {
        // component
        //   .querySelector(
        //     `.answer-container .${container} .audio-progress .progress-filling`
        //   )
        //   .css('width', `${(_audio.currentTime / _audio.duration) * 100}%`);
      };
      audio.addEventListener('ended', () => {
        component.isPause = false ;
      });
    }

    // Action triggered when pause audio
    private onPauseAudio() {
      const component = this;
      const audio = component.audioRecorder;
      audio.pause();
      this.isPause = true;
    }


    // --------------------------------------------------------------
    // Methods




}
